__webpack_require__.p = "/angular-ts-update/referrals/";